import { RootState } from '@/stores'
import { useSelector } from 'react-redux'

export interface useChannelFixingPositionResult {
  checkValidity: () => boolean
}

const useDesignValidity = (): useChannelFixingPositionResult => {
  const minimumAnchorCount = 2
  const minimumTBoltCount = 1

  const design = useSelector((state: RootState) => state.activeDesign.design)

  const checkValidity = () => {
    const castInChannel = design?.components.find((component) => {
      return Object.prototype.hasOwnProperty.call(component, 'cast_in_anchor_channel')
    })

    const tBolts =  design?.components?.filter(c => c.parent_id === castInChannel?.id)

    const hasEnoughAnchors = (castInChannel?.cast_in_anchor_channel?.anchor_spacings?.length ?? 0) >= minimumAnchorCount
    const hasEnoughTBolts = (tBolts?.length ?? 0) >= minimumTBoltCount

    return hasEnoughAnchors && hasEnoughTBolts
  }

  return {
    checkValidity,
  }
}

export default useDesignValidity
